import { Component,ViewChild } from '@angular/core';
import { IonicPage, NavController, NavParams, AlertController } from 'ionic-angular';
import { GraficasProvider } from '../../providers/graficas/graficas'
import { Chart } from 'chart.js';
import { ClientesProvider } from '../../providers/clientes/clientes'
import { AuthService } from '../../providers/auth-service'
import { CompaniasProvider } from '../../providers/companias/companias'
import * as papa from 'papaparse'
import { UsuariosProvider } from '../../providers/usuarios/usuarios'
import { NUBE_AWS } from '../../config/url.servicio';


@IonicPage()
@Component({
  selector: 'page-informe-gestiones',
  templateUrl: 'informe-gestiones.html',
  providers: [ AuthService ]
})
export class InformeGestionesPage {
  @ViewChild('barCanvas') barCanvas;
  @ViewChild('barCanvasafn') barCanvasafn;
  @ViewChild('doughnutCanvas') doughnutCanvas;
  @ViewChild('lineCanvas') lineCanvas;
  @ViewChild('doughnutCanvasUno') doughnutCanvasUno;
  @ViewChild('doughnutCanvasDos') doughnutCanvasDos;
  @ViewChild('doughnutCanvasTres') doughnutCanvasTres;

  barChart: any;
  doughnutChart: any;
  doughnutChartUno: any;
  doughnutChartDos: any;
  doughnutChartTres: any;
  lineChart: any;
  data = []
  datos = ""
  labels = ""
  dataReal = [{valorReal:-1}]
  nombreCompaniaHeader:any=""
  nombreCargoHeader:any=""
  parsedData:any
  parsedDataReal:any
  parseDataHeader:any

  parsedDataSemanalesPorDia:any
  parsedDataRealSemanalesPorDia:any
  parseDataHeaderSemanalesPorDia:any

  parsedDataMensualesPorSemana:any
  parsedDataRealMensualesPorSemana:any
  parseDataHeaderMensualesPorSemana:any

  parsedDataAnualesPorMes:any
  parsedDataRealAnualesPorMes:any
  parsedDataRealAnualesPorMesAFN:any
  parseDataHeaderAnualesPorMes:any

  parsedDataproducto:any
  parsedDataRealproducto:any
  parseDataHeaderproducto:any
  companiasId : any = null
  fechaDesde:Date
  fechaHasta:Date
  constructor(public navCtrl: NavController, public navParams: NavParams,
              public servicio:GraficasProvider,
              public utils:ClientesProvider,
              public auth: AuthService,
              public servicioCompania:CompaniasProvider,
              public serviciUsuario:UsuariosProvider,
              public alertCtrl:AlertController) {


                this.servicioCompania.devolverVarios(['nombreCompania','nombreCargo','usuariosId','companiasId'])
                .then((val)=>{
                  if(val){
                    this.nombreCompaniaHeader = val['nombreCompania']
                    this.nombreCargoHeader = val['nombreCargo']
                    let codigo = val['usuariosId']
                    this.companiasId = val['companiasId']
                    this.serviciUsuario.buscarUsuarioAdministrador(codigo).subscribe((data)=>{
                      data = NUBE_AWS ? JSON.parse(data['_body']).data[0]: data
                      if(!data[0].administrador){
                        this.showAlert('No tiene permiso para ver los informes')
                        this.navCtrl.setRoot('HomePage');
                      }
                    },(error)=>{

                      this.navCtrl.setRoot('HomePage');
                    })
                  }
                })
  }

  showAlert(msj) {
    let alert = this.alertCtrl.create({
      title: 'Verifique..',
      subTitle: msj,
      buttons: ['OK']
    });
    alert.present();
  }

  ionViewDidLoad() {
    let fechaInicial = this.devolverFecha(0)
    let fechaFinal = this.devolverFecha(0)
    let fechaInicialSemanaAntes = this.devolverFecha(7)
    let fechaInicialMensualAntes = this.devolverFecha(30)
    let fechaInicialAnualAntes = this.devolverFecha(365)
    this.buscarGestionTurnos(fechaInicial,fechaFinal)
    this.buscarGestionTurnosSemanales(fechaInicialSemanaAntes,fechaFinal)
    this.buscarGestionTurnosMensuales(fechaInicialMensualAntes,fechaFinal)
    this.buscarGestionTurnosAnual(fechaInicialAnualAntes,fechaFinal)
  }

  buscarProductos(){
    this.servicio.buscarProductos()
    .subscribe((data)=>{

        let realvalorgrid = ''

        for(var i = 0; i< data[0].length;i++){

            if(i==0){
              realvalorgrid+= 'nombre,existenciasActuales,existenciasMinimas,valorVenta,productosId,nombreCompania' + '\n'
            }else{
              realvalorgrid+= data[0][i]['nombre']  + ',' + data[0][i]['existenciasActuales']   + ',' + data[0][i]['existenciasMinimas'] + ',' + data[0][i]['valorVenta'] + ',' + data[0][i]['productosId']  + ',' + data[0][i]['nombreCompania'] + '\n'
            }

        }
        this.parsedDataproducto = papa.parse(realvalorgrid).data

        this.parseDataHeaderproducto =  this.parsedDataproducto[0]
        this.parsedDataproducto.splice(0,1)
        this.parsedDataRealproducto = this.parsedDataproducto

    },error=>{
        console.log(error)
    })



  }

  buscarVentasDiarias(){
    this.servicioCompania.devolverVarios(['companiasId'])
    .then((val)=>{
      let companiasId = val['companiasId']

    this.servicio.buscarVentasDiarias(this.companiasId)
    .subscribe((data:any)=>{
      data = NUBE_AWS ? JSON.parse(data['_body']).data[0]: data
      // if(data.length == []){
      //   return
      // }
      if(data.length == 0){
        return
      }
        let valorinicial = []
        let valorfinal = []

        let realvalorgrid = ''
        let realvalorgridHeader = ''
        for(var i = 0; i< data.length;i++){
            valorinicial[i]= data[i]['valorVenta']

            valorfinal[i] = data[i]['horaVenta']
            if(i==0){
              realvalorgrid+= 'hora Venta,valor Venta' + '\n'
            }else{
              realvalorgrid+= data[i]['horaVenta']  + ',' + data[i]['valorVenta']  + '\n'
            }

        }

        this.parsedData = papa.parse(realvalorgrid).data

        this.parseDataHeader =  this.parsedData[0]
        this.parsedData.splice(0,1)
        this.parsedDataReal = this.parsedData


       this.graficas(valorinicial,valorfinal)
    },error=>{
        console.log(error)
    })
  })
  }

  trackByFn(index:any,item:any){
    return index;
  }

  descargarProducto(name:any){
    let csv = papa.unparse({
      fields: this.parseDataHeaderproducto,
      data: this.parsedDataRealproducto
    })

    var blob = new Blob([csv])
    var a = window.document.createElement("a")
    a.href = window.URL.createObjectURL(blob)
    a.download = name + '.csv'
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
  }

  actualizarProducto(name:any){

   let   data = this.parsedDataRealproducto

   for(let i=0;i < data.length;i++){
      let producto: any = {
        existenciasMinimas: Number(data[i][2]),
        existenciasActuales: Number(data[i][1]),
        productosId: Number(data[i][4]),
        queHago: "A",
        nombreTabla: "productos",
        name: "dataDynamicCrud"
      }

     //?name=dataDynamicCrud&paisesId=${pais.paisesId}&codigoPais=${pais.codigoPais}&nombrePais=${pais.nombrePais}&nombreTabla=paises
     this.servicio.actualizarProducto(producto).subscribe((item)=>{
      console.log(item)
     },(error) => {
       console.log(error)
     })

   }

  }

  descargar(name:any){



    let csv = papa.unparse({
      fields: this.parseDataHeader,
      data: this.parsedDataReal
    })

    var blob = new Blob([csv])
    var a = window.document.createElement("a")
    a.href = window.URL.createObjectURL(blob)
    a.download = name + '.csv'
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
  }

  descargarSemanal(name:any){

    let csv = papa.unparse({
      fields: this.parseDataHeaderSemanalesPorDia,
      data: this.parsedDataRealSemanalesPorDia
    })

    var blob = new Blob([csv])
    var a = window.document.createElement("a")
    a.href = window.URL.createObjectURL(blob)
    a.download = name + '.csv'
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
  }

  descargarMensual(name:any){

    let csv = papa.unparse({
      fields: this.parseDataHeaderMensualesPorSemana,
      data: this.parsedDataRealMensualesPorSemana
    })

    var blob = new Blob([csv])
    var a = window.document.createElement("a")
    a.href = window.URL.createObjectURL(blob)
    a.download = name + '.csv'
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
  }

  descargarAnual(name:any){

    const lines =  this.parsedDataRealAnualesPorMesAFN.split('\n');

    // Dividir cada línea en elementos separados por comas y crear un array multidimensional
    const values = lines.map(line => line.split(','));

    let csv = papa.unparse({
      fields: this.parseDataHeaderAnualesPorMes,
      data: values
    })
    var blob = new Blob([csv])
    var a = window.document.createElement("a")
    a.href = window.URL.createObjectURL(blob)
    a.download = name + '.csv'
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
  }

  ventasSemanalesPorDia(){
    this.servicioCompania.devolverVarios(['companiasId'])
    .then((val)=>{
      let companiasId = val['companiasId']

      this.servicio.buscarVentasSemanalesPorDias(companiasId)
      .subscribe((data)=>{
        data = NUBE_AWS ? JSON.parse(data['_body']).data[0]: data
        // if(data.length == []){
        //   return
        // }
        if(data.length == 0){
          return
        }
          let valorinicial = []
          let valorfinal = []

          let realvalorgrid = ''

          for(var i = 0; i< data.length;i++){
              valorinicial[i]= data[i]['valorVenta']

              valorfinal[i] = data[i]['fechaVenta']
              if(i==0){
                realvalorgrid+= 'Fecha Venta,valor Venta' + '\n'
              }else{
                realvalorgrid+= data[i]['fechaVenta']  + ',' + data[i]['valorVenta'] + '\n'
              }

          }

          this.parsedDataSemanalesPorDia = papa.parse(realvalorgrid).data

          this.parseDataHeaderSemanalesPorDia =  this.parsedDataSemanalesPorDia[0]
          this.parsedDataSemanalesPorDia.splice(0,1)
          this.parsedDataRealSemanalesPorDia = this.parsedDataSemanalesPorDia


          // for(var i = 0; i< data[0].length;i++){
          //     valorinicial[i]= data[0][i]['valorVenta']

          //     valorfinal[i] = data[0][i]['fechaVenta']

          // }
          this.graficaventasSemanalesPorDia(valorinicial,valorfinal)
      },error=>{
          console.log(error)
      })
    })

  }

  ventasMensualesPorSemana(){
    this.servicioCompania.devolverVarios(['companiasId'])
    .then((val)=>{
      let companiasId = val['companiasId']

    this.servicio.buscarventasMensualesPorSemanas(companiasId)
    .subscribe((data)=>{
      data = NUBE_AWS ? JSON.parse(data['_body']).data[0]: data
      // if(data.length == []){
      //   return
      // }
      if(data.length == 0){
        return
      }
        let valorinicial = []
        let valorfinal = []


        let realvalorgrid = ''

        for(var i = 0; i< data.length;i++){
          valorinicial[i]= data[i]['valorVenta']
          let valoruno = ""
          valoruno = data[i]['semanaDesde']
          valoruno = valoruno.substr(0,10)
          let valordos = ""
          valordos = data[i]['semanaHasta']
          valordos = valordos.substr(0,10)

          valorfinal[i] =`Desde ${valoruno} Hasta ${valordos}`
          if(data.length == 1 && i ==0){
            realvalorgrid+= 'Semana Desde  - Semana Hasta,valor Venta' + '\n'
            realvalorgrid+='Desde ' + valoruno + ' Hasta ' + valordos  + ',' + data[i]['valorVenta'] +  '\n'
          }else{
            if(i==0){
              realvalorgrid+= 'Semana Desde  - Semana Hasta,valor Venta' + '\n'
            }else{
              realvalorgrid+='Desde ' + valoruno + ' Hasta ' + valordos  + ',' + data[i]['valorVenta'] +  '\n'
            }
          }

      }

      // if(realvalorgrid == "" && data.length ===undefined && data.valorVenta !== ""){

      //   let valor = data
      //   realvalorgrid+= 'Semana Desde  - Semana Hasta,valor Venta' + '\n'
      //   valorinicial[i]= valor.valorVenta
      //   let valoruno = ""
      //   valoruno = valor.semanaDesde
      //   valoruno = valoruno.substr(0,10)
      //   let valordos = ""
      //   valordos = valor.semanaHasta
      //   valordos = valordos.substr(0,10)
      //   realvalorgrid+='Desde ' + valoruno + ' Hasta ' + valordos  + ',' + valor.valorVenta +  '\n'

      // }



        this.parsedDataMensualesPorSemana = papa.parse(realvalorgrid).data

        this.parseDataHeaderMensualesPorSemana =  this.parsedDataMensualesPorSemana[0]
        this.parsedDataMensualesPorSemana.splice(0,1)
        this.parsedDataRealMensualesPorSemana = this.parsedDataMensualesPorSemana



        // for(var i = 0; i< data[0].length;i++){
        //     valorinicial[i]= data[0][i]['valorVenta']
        //     let valoruno = ""
        //     valoruno = data[0][i]['semanaDesde']
        //     valoruno = valoruno.substr(0,10)
        //     let valordos = ""
        //     valordos = data[0][i]['semanaHasta']
        //     valordos = valordos.substr(0,10)

        //     valorfinal[i] =`Desde ${valordos} Hasta ${valordos}`

        // }
        this.graficaMensualesPorSemana(valorinicial,valorfinal)
    },error=>{
        console.log(error)
    })
  })
  }

  ventasAnualesPorMes(){
    this.servicioCompania.devolverVarios(['companiasId'])
    .then((val)=>{
      let companiasId = val['companiasId']

    this.servicio.buscarventasAnualesPorMes(companiasId)
    .subscribe((data)=>{
      data = NUBE_AWS ? JSON.parse(data['_body']).data[0]: data
      // if(data.length == []){
      //   return
      // }
      if(data.length == 0){
        return
      }
        let valorinicial = []
        let valorfinal = []

        let realvalorgrid = ''

        for(var i = 0; i< data.length;i++){
            valorinicial[i]= data[i]['valorVenta']

            valorfinal[i] = data[i]['mesVenta']
            if(data.length == 1  && i ==0){
              realvalorgrid+= 'Mes Venta,valor Venta' + '\n'
              realvalorgrid+= data[i]['mesVenta']  + ',' + data[i]['valorVenta'] + '\n'
            }else{
              if(i==0){
                realvalorgrid+= 'Mes Venta,valor Venta' + '\n'
              }else{
                realvalorgrid+= data[i]['mesVenta']  + ',' + data[i]['valorVenta'] + '\n'
              }
            }


        }

        // if(realvalorgrid == "" && data[0].length ===undefined && data[0].valorVenta !== ""){

        //   let valor = data[0]
        //   realvalorgrid+= 'Mes Venta,valor Venta' + '\n'
        //       realvalorgrid+= valor.mesVenta  + ',' + valor.valorVenta + '\n'

        // }

        this.parsedDataAnualesPorMes = papa.parse(realvalorgrid).data

        this.parseDataHeaderAnualesPorMes =  this.parsedDataAnualesPorMes[0]
        this.parsedDataAnualesPorMes.splice(0,1)
        this.parsedDataRealAnualesPorMes = this.parsedDataAnualesPorMes

        // for(var i = 0; i< data[0].length;i++){
        //     valorinicial[i]= data[0][i]['valorVenta']

        //     valorfinal[i] = data[0][i]['mesVenta']

        // }
        this.graficaventasAnualesPorMes(valorinicial,valorfinal)
    },error=>{
        console.log(error)
    })
  })
  }

  groupBy(list, keyGetter) {
    const map = new Map();
    list.forEach((item) => {
        const key = keyGetter(item);
        const collection = map.get(key);
        if (!collection) {
            map.set(key, [item]);
        } else {
            collection.push(item);
        }
    });
    return map;
}

graficas(datos:any, labels:any){
  this.doughnutChart = new Chart(this.doughnutCanvas.nativeElement, {
      type: 'doughnut',
      data: {
          labels: labels,
          datasets: [{
              label: 'Ventas por usuario',
              backgroundColor: ["#3e95cd", "#8e5ea2","#3cba9f","#e8c3b9","#c45850"],
              data: datos,
          }]
      },
      options: {
          responsive: true,
          aspectRatio: 1, // Puedes ajustar el aspectRatio según tus necesidades
          maintainAspectRatio: true,
          legend: {
              display: true,
              position: "top",
              title: {
                  display: true,
                  text: 'Ventas por usuario'
              }
          },
          tooltips: {
            enabled: true, // Habilitar tooltips
            callbacks: {
              label: function(tooltipItem, data) {
                var dataset = data.datasets[tooltipItem.datasetIndex];
                var meta = dataset._meta[Object.keys(dataset._meta)[0]];
                var total = meta.total;
                var currentValue = dataset.data[tooltipItem.index];
                var percentage = parseFloat((currentValue / total * 100).toFixed(1));
                return currentValue.toLocaleString('en-US', { maximumFractionDigits: 2 }) + ' (' + percentage + '% of ' + total.toLocaleString('en-US', { maximumFractionDigits: 2 }) + ')';
              }
            }
          }

      }
  });
}


graficasSemanales(datos:any, labels:any){
  this.doughnutChartUno = new Chart(this.doughnutCanvasUno.nativeElement, {
      type: 'doughnut',
      data: {
          labels: labels,
          datasets: [{
              label: 'Ventas usuario semanal',
              backgroundColor: ["#3e95cd", "#8e5ea2","#3cba9f","#e8c3b9","#c45850"],
              data: datos,
          }]
      },
      options: {
          responsive: true,
          aspectRatio: 1, // Puedes ajustar el aspectRatio según tus necesidades
          maintainAspectRatio: true,
          legend: {
              display: true,
              position: "top",
              title: {
                  display: true,
                  text: 'Ventas usuario semanal'
              }
          },
          tooltips: {
            enabled: true, // Habilitar tooltips
            callbacks: {
              label: function(tooltipItem, data) {
                var dataset = data.datasets[tooltipItem.datasetIndex];
                var meta = dataset._meta[Object.keys(dataset._meta)[0]];
                var total = meta.total;
                var currentValue = dataset.data[tooltipItem.index];
                var percentage = parseFloat((currentValue / total * 100).toFixed(1));
                return currentValue.toLocaleString('en-US', { maximumFractionDigits: 2 }) + ' (' + percentage + '% of ' + total.toLocaleString('en-US', { maximumFractionDigits: 2 }) + ')';
              }
            }
          }

      }
  });
}


graficasAnual(datos:any, labels:any){
  this.doughnutChartTres = new Chart(this.doughnutCanvasTres.nativeElement, {
      type: 'doughnut',
      data: {
          labels: labels,
          datasets: [{
              label: 'Ventas mensuales',
              backgroundColor: ["#3e95cd", "#8e5ea2","#3cba9f","#e8c3b9","#c45850"],
              data: datos,
          }]
      },
      options: {
          responsive: true,
          aspectRatio: 1, // Puedes ajustar el aspectRatio según tus necesidades
          maintainAspectRatio: true,
          legend: {
              display: true,
              position: "top",
              title: {
                  display: true,
                  text: 'Ventas mensuales'
              }
          },
          tooltips: {
            enabled: true, // Habilitar tooltips
            callbacks: {
              label: function(tooltipItem, data) {
                var dataset = data.datasets[tooltipItem.datasetIndex];
                var meta = dataset._meta[Object.keys(dataset._meta)[0]];
                var total = meta.total;
                var currentValue = dataset.data[tooltipItem.index];
                var percentage = parseFloat((currentValue / total * 100).toFixed(1));
                return currentValue.toLocaleString('en-US', { maximumFractionDigits: 2 }) + ' (' + percentage + '% of ' + total.toLocaleString('en-US', { maximumFractionDigits: 2 }) + ')';
              }
            }
          }

      }
  });
}


graficasMensual(datos:any, labels:any){
  this.doughnutChartDos = new Chart(this.doughnutCanvasDos.nativeElement, {
      type: 'doughnut',
      data: {
          labels: labels,
          datasets: [{
              label: 'Ventas mensuales',
              backgroundColor: ["#3e95cd", "#8e5ea2","#3cba9f","#e8c3b9","#c45850"],
              data: datos,
          }]
      },
      options: {
          responsive: true,
          aspectRatio: 1, // Puedes ajustar el aspectRatio según tus necesidades
          maintainAspectRatio: true,
          legend: {
              display: true,
              position: "top",
              title: {
                  display: true,
                  text: 'Ventas mensuales'
              }
          },
          tooltips: {
            enabled: true, // Habilitar tooltips
            callbacks: {
              label: function(tooltipItem, data) {
                var dataset = data.datasets[tooltipItem.datasetIndex];
                var meta = dataset._meta[Object.keys(dataset._meta)[0]];
                var total = meta.total;
                var currentValue = dataset.data[tooltipItem.index];
                var percentage = parseFloat((currentValue / total * 100).toFixed(1));
                return currentValue.toLocaleString('en-US', { maximumFractionDigits: 2 }) + ' (' + percentage + '% of ' + total.toLocaleString('en-US', { maximumFractionDigits: 2 }) + ')';
              }
            }
          }

      }
  });
}


graficasTwo(datoss:any,labesl:any){

    this.doughnutChart = new Chart(this.doughnutCanvas.nativeElement, {

        type: 'bar',
        data: {
            labels: labesl,
            datasets: [{
                label: datoss,
                backgroundColor: ["#3e95cd", "#8e5ea2","#3cba9f","#e8c3b9","#c45850"],
                data:datoss,

            }]
        },
       options: {
    responsive: true,
    aspectRatio: 1,
    maintainaApectRatio: true,
    onResize: function () {
      if (window.innerWidth > 700) {
        this.legend.position = 'right';
        this.legend.aspectRatio = 1.4;
        this.legend.maintainaApectRatio = false;
      } else {
        this.legend.position = 'bottom';
        this.legend.aspectRatio = 1;
        this.legend.maintainaApectRatio = true;
      }
    },
    legend: {
      display: true,
      position: "top",
          title: {
      display: true,
      text: 'Ventas por hora'
    },
      labels: {

      }
    }
  }

    });

}


graficaventasSemanalesPorDia(datoss:any,labesl:any){

    this.doughnutChartUno = new Chart(this.doughnutCanvasUno.nativeElement, {
    // new Chart(document.getElementById("bar-chart"), {
        type: 'bar',
        data: {
          labels:labesl,
          datasets: [
            {
              label: datoss,
              backgroundColor: ["#3e95cd", "#8e5ea2","#3cba9f","#e8c3b9","#c45850"],
              data:datoss
            }
          ]
        },
        options: {
          legend: { display: true },
          title: {
            display: true,
            text: 'Ventas última Semana'
          }
        }
    // });
 });

}

graficaMensualesPorSemana(datoss:any,labesl:any){

    this.doughnutChartDos = new Chart(this.doughnutCanvasDos.nativeElement, {


    type: 'bar',
    data: {
      labels:labesl,
      datasets: [
        {
          label: datoss,
          backgroundColor: ["#3e95cd", "#8e5ea2","#3cba9f","#e8c3b9","#c45850"],
          data:datoss
        }
      ]
    },
    options: {
      legend: { display: true },
      title: {
        display: true,
        text: 'Ventas Mensuales'
      }
    }});
}

graficaventasAnualesPorMes(datoss:any,labesl:any){

    this.doughnutChartTres = new Chart(this.doughnutCanvasTres.nativeElement, {
        type: 'bar',
        data: {
          labels:labesl,
          datasets: [
            {
              label: datoss,
              backgroundColor: ["#3e95cd", "#8e5ea2","#3cba9f","#e8c3b9","#c45850"],
              data:datoss
            }
          ]
        },
        options: {
          legend: { display: true },
          title: {
            display: true,
            text: 'Ventas Anuales por mes'
          }
        }
    });

}



chat(){
    this.navCtrl.push('ChatPage');
}

buscarTodosLosValores(){

}
cerrarSession(){
    this.auth.logout()
    this.navCtrl.setRoot('LoginPage');
  }

  buscarGestionTurnos(fechaDesde: any,fechaHasta: any){
    this.servicioCompania.devolverVarios(['companiasId'])
    .then((val)=>{
      let companiasId = val['companiasId']
      this.fechaDesde = fechaDesde
      this.fechaHasta = fechaHasta
      this.parsedData = [];
      this.parseDataHeader = [];
      this.parsedDataReal = [];
    this.servicio.buscarGestionTurnos(this.companiasId,this.fechaDesde, this.fechaHasta)
    .subscribe((data:any)=>{
      data = NUBE_AWS ? JSON.parse(data['_body']).data[0]: data
      // if(data.length == []){
      //   return
      // }
      if(data.length == 0){
        return
      }
       // Definir un objeto para almacenar los totales por nombre de usuario
let totalsByUser = {};

// Iterar sobre los datos para calcular los totales por nombre de usuario
for (let i = 0; i < data.length; i++) {
    let valorVenta = data[i]['valorVenta'];
    let nombreUsuario = data[i]['nombreUsuario'];

    // Totalizar las ventas por nombre de usuario
    if (totalsByUser[nombreUsuario]) {
        totalsByUser[nombreUsuario] += valorVenta;
    } else {
        totalsByUser[nombreUsuario] = valorVenta;
    }
}

// Preparar los datos para usarlos en la gráfica de barras
let valorfinal = Object.keys(totalsByUser); // Nombre de usuario
let valorinicial = Object.keys(totalsByUser).map(key => totalsByUser[key]); // Total de venta por usuario

// Crear una cadena CSV para la visualización de los datos
let realvalorgrid = 'nombre Usuario,valor Venta' + '\n';
for (let i = 0; i < valorfinal.length; i++) {
    realvalorgrid += valorfinal[i] + ',' + valorinicial[i] + '\n';
}

  // Parsear los datos utilizando la librería PapaParse
  // this.parsedData = papa.parse(realvalorgrid).data;
  if (!realvalorgrid.endsWith('\n')) {
    realvalorgrid += '\n';  // Agregar salto de línea al final de la última fila si no existe
  }
  this.parsedData = papa.parse(realvalorgrid).data;
  this.parseDataHeader = this.parsedData[0];
  if (this.parsedData && Array.isArray(this.parsedData)) {
    this.parsedData.splice(0, 1);
  }
  this.parsedDataReal = this.parsedData;

  // Llamar a la función de creación de gráficas con los datos totalizados por nombre de usuario
  this.graficas(valorinicial, valorfinal);
      },error=>{
          console.log(error)
      })
    })
  }


  buscarTodasLasGestiones(fechaDesde: any,fechaHasta: any) {
    this.buscarGestionTurnos(fechaDesde,fechaHasta)
  }

  buscarGestionTurnosSemanales(fechaDesde: any,fechaHasta: any){
    this.servicioCompania.devolverVarios(['companiasId'])
    .then((val)=>{
      let companiasId = val['companiasId']
      let fechaDesdeReal = fechaDesde
      this.fechaHasta = fechaHasta
      this.parsedDataRealSemanalesPorDia = []
      this.parseDataHeaderSemanalesPorDia = []
    this.servicio.buscarGestionTurnos(this.companiasId,fechaDesdeReal, this.fechaHasta)
    .subscribe((data:any)=>{
      data = NUBE_AWS ? JSON.parse(data['_body']).data[0]: data
      // if(data.length == []){
      //   return
      // }
      if(data.length == 0){
        return
      }
// Definir un objeto para almacenar los totales por nombre de usuario y semana
let totalsByUserAndWeek = {};

// Iterar sobre los datos para calcular los totales por nombre de usuario y semana
for (let i = 0; i < data.length; i++) {
    let valorVenta = data[i]['valorVenta'];
    let nombreUsuario = data[i]['nombreUsuario'];
    let fechaVenta = new Date(data[i]['fechaVenta']);

    // Calcular el número de semana del año
    let numSemana = getWeekNumber(fechaVenta);

    // Crear una clave única para identificar al usuario y la semana
    let claveUnica = nombreUsuario + '-' + numSemana;

    // Totalizar las ventas por nombre de usuario y semana
    if (totalsByUserAndWeek[claveUnica]) {
        totalsByUserAndWeek[claveUnica] += valorVenta;
    } else {
        totalsByUserAndWeek[claveUnica] = valorVenta;
    }
}

// Función para obtener el número de semana del año
function getWeekNumber(date) {
  let d = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
  let dayNum = d.getUTCDay() || 7;
  d.setUTCDate(d.getUTCDate() + 4 - dayNum);
  let yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
  return Math.ceil((((Number(d) - Number(yearStart)) / 86400000) + 1) / 7);
}

// Preparar los datos para usarlos en la gráfica de barras
let valorfinal = Object.keys(totalsByUserAndWeek).map(clave => clave.split('-')[0]); // Nombre de usuario
let valorinicial = Object.keys(totalsByUserAndWeek).map(clave => totalsByUserAndWeek[clave]); // Total de venta por usuario y semana

// Crear una cadena CSV para la visualización de los datos
let realvalorgrid = 'nombre Usuario,valor Venta' + '\n';
for (let i = 0; i < valorfinal.length; i++) {
    realvalorgrid += valorfinal[i] + ',' + valorinicial[i] + '\n';
}

  // Parsear los datos utilizando la librería PapaParse
  // this.parsedData = papa.parse(realvalorgrid).data;
  if (!realvalorgrid.endsWith('\n')) {
    realvalorgrid += '\n';  // Agregar salto de línea al final de la última fila si no existe
  }
  this.parsedDataRealSemanalesPorDia = papa.parse(realvalorgrid).data;
  this.parseDataHeaderSemanalesPorDia = this.parsedDataRealSemanalesPorDia[0];
  if (this.parsedDataRealSemanalesPorDia && Array.isArray(this.parsedDataRealSemanalesPorDia)) {
    this.parsedDataRealSemanalesPorDia.splice(0, 1);
  }
  this.parsedDataRealSemanalesPorDia = this.parsedDataRealSemanalesPorDia;

  // Llamar a la función de creación de gráficas con los datos totalizados por nombre de usuario
  this.graficasSemanales(valorinicial, valorfinal);
      },error=>{
          console.log(error)
      })
    })
  }


  buscarGestionTurnosMensuales(fechaDesde: any,fechaHasta: any){
    this.servicioCompania.devolverVarios(['companiasId'])
    .then((val)=>{
      let companiasId = val['companiasId']
      let fechaDesdeReal = fechaDesde
      this.fechaHasta = fechaHasta
      this.parsedDataRealMensualesPorSemana = []
      this.parseDataHeaderMensualesPorSemana = []
    this.servicio.buscarGestionTurnos(this.companiasId,fechaDesdeReal, this.fechaHasta)
    .subscribe((data:any)=>{
      data = NUBE_AWS ? JSON.parse(data['_body']).data[0]: data
      // if(data.length == []){
      //   return
      // }
      if(data.length == 0){
        return
      }
// Definir un objeto para almacenar los totales por nombre de usuario y semana
let totalsByUserAndMonth = {};

for (let i = 0; i < data.length; i++) {
    let valorVenta = data[i]['valorVenta'];
    let nombreUsuario = data[i]['nombreUsuario'];
    let fechaVenta = new Date(data[i]['fechaVenta']);

    // Calcular el número de mes
    let numMes = fechaVenta.getMonth(); // Obtener el número de mes (de 0 a 11)

    // Crear una clave única para identificar al usuario y el mes
    let claveUnica = nombreUsuario + '-' + numMes;

    // Totalizar las ventas por nombre de usuario y mes
    if (totalsByUserAndMonth[claveUnica]) {
        totalsByUserAndMonth[claveUnica] += valorVenta;
    } else {
        totalsByUserAndMonth[claveUnica] = valorVenta;
    }
}

// Preparar los datos para usar en la visualización de las gráficas
let valorfinal = Object.keys(totalsByUserAndMonth).map(clave => clave.split('-')[0]); // Nombre de usuario
let valorinicial = Object.keys(totalsByUserAndMonth).map(clave => totalsByUserAndMonth[clave]); // Total de venta por usuario y mes

// Crear una cadena CSV para la visualización de los datos
let realvalorgrid = 'nombre Usuario,valor Venta' + '\n';
for (let i = 0; i < valorfinal.length; i++) {
    realvalorgrid += valorfinal[i] + ',' + valorinicial[i] + '\n';
}

// Parsear los datos utilizando la librería PapaParse
if (!realvalorgrid.endsWith('\n')) {
    realvalorgrid += '\n';  // Agregar salto de línea al final de la última fila si no existe
}
this.parsedDataRealMensualesPorSemana = papa.parse(realvalorgrid).data;
this.parseDataHeaderMensualesPorSemana = this.parsedDataRealMensualesPorSemana[0];
if (this.parsedDataRealMensualesPorSemana && Array.isArray(this.parsedDataRealMensualesPorSemana)) {
    this.parsedDataRealMensualesPorSemana.splice(0, 1);
}
this.parsedDataRealMensualesPorSemana = this.parsedDataRealMensualesPorSemana;

  // Llamar a la función de creación de gráficas con los datos totalizados por nombre de usuario
  this.graficasMensual(valorinicial, valorfinal);
      },error=>{
          console.log(error)
      })
    })
  }


  buscarGestionTurnosAnual(fechaDesde: any,fechaHasta: any){
    this.servicioCompania.devolverVarios(['companiasId'])
    .then((val)=>{
      let companiasId = val['companiasId']
      let fechaDesdeReal = fechaDesde
      this.fechaHasta = fechaHasta
      this.parsedDataAnualesPorMes = []
      this.parseDataHeaderAnualesPorMes = []
    this.servicio.buscarGestionTurnos(this.companiasId,fechaDesdeReal, this.fechaHasta)
    .subscribe((data:any)=>{
      data = NUBE_AWS ? JSON.parse(data['_body']).data[0]: data
      // if(data.length == []){
      //   return
      // }
      if(data.length == 0){
        return
      }
      let totalsByUserAndYear = {};

      for (let i = 0; i < data.length; i++) {
          let valorVenta = data[i]['valorVenta'];
          let nombreUsuario = data[i]['nombreUsuario'];
          let fechaVenta = new Date(data[i]['fechaVenta']);

          // Calcular el año
          let anio = fechaVenta.getFullYear(); // Obtener el año de la fecha

          // Crear una clave única para identificar al usuario y el año
          let claveUnica = nombreUsuario + '-' + anio;

          // Totalizar las ventas por nombre de usuario y año
          if (totalsByUserAndYear[claveUnica]) {
              totalsByUserAndYear[claveUnica] += valorVenta;
          } else {
              totalsByUserAndYear[claveUnica] = valorVenta;
          }
      }

      // Preparar los datos para usar en la visualización de las gráficas
      let valorfinal = Object.keys(totalsByUserAndYear).map(clave => clave.split('-')[0]); // Nombre de usuario
      let valorinicial = Object.keys(totalsByUserAndYear).map(clave => totalsByUserAndYear[clave]); // Total de venta por usuario y año

      // Crear una cadena CSV para la visualización de los datos
      let realvalorgrid = 'nombre Usuario,valor Venta' + '\n';
      for (let i = 0; i < valorfinal.length; i++) {
          realvalorgrid += valorfinal[i] + ',' + valorinicial[i] + '\n';
      }

      // Parsear los datos utilizando la librería PapaParse
      if (!realvalorgrid.endsWith('\n')) {
          realvalorgrid += '\n';  // Agregar salto de línea al final de la última fila si no existe
      }
      this.parsedDataAnualesPorMes = papa.parse(realvalorgrid).data;
      this.parseDataHeaderAnualesPorMes = this.parsedDataAnualesPorMes[0];
      if (this.parsedDataAnualesPorMes && Array.isArray(this.parsedDataAnualesPorMes)) {
          this.parsedDataAnualesPorMes.splice(0, 1);
      }
      this.parsedDataRealAnualesPorMesAFN = realvalorgrid;

  // Llamar a la función de creación de gráficas con los datos totalizados por nombre de usuario
  this.graficasAnual(valorinicial, valorfinal);
      },error=>{
          console.log(error)
      })
    })
  }



  devolverFecha(dias:any): string {
    const f = new Date();
    f.setDate(f.getDate() - Number(dias)); // Restar 7 días a la fecha actual

    const year = f.getFullYear();
    const month = (f.getMonth() + 1) < 10 ? '0' + (f.getMonth() + 1) : (f.getMonth());
    const day = f.getDate() < 10 ? '0' + f.getDate() : f.getDate();

    return `${year}-${month}-${day}`;
}



}



// WEBPACK FOOTER //
// ./src/pages/informe-gestiones/informe-gestiones.ts